import { resolveGuideValidUntil } from '@/lib/guide-validity'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { MdEventAvailable, MdEventBusy } from 'react-icons/md'

interface Props {
    /** Emissão do documento (`createdAt` do exame/consulta/procedimento). */
    issuedAt?: string | Date | null
    /** Dias configurados na empresa (`useGuideValidityDays`). `null` = carregando. */
    days: number | null
    /** Vencimento renovado manualmente pelo operador (`guideValidUntil`). Tem prioridade. */
    guideValidUntil?: string | Date | null
}

/**
 * Linha "Guia válida até dd/mm/aaaa" nas telas de detalhe. Mostra a MESMA data que
 * o backend imprime no PDF (mesma regra: emissão + dias). Quando a guia já venceu,
 * fica em vermelho — o atendente precisa ver isso antes de mandar o paciente.
 *
 * Não renderiza nada enquanto a configuração carrega (`days === null`) nem quando a
 * validade está desligada (0 dias).
 */
export function GuideValidityLine({ issuedAt, days, guideValidUntil }: Props) {
    const validUntil = resolveGuideValidUntil(guideValidUntil, issuedAt, days)
    if (!validUntil) return null

    const expired = validUntil.getTime() < Date.now()
    const dateLabel = format(validUntil, "dd 'de' MMMM 'de' yyyy", { locale: ptBR })

    return (
        <div
            className={`flex items-center gap-2 text-sm ${
                expired ? 'text-error font-medium' : 'text-base-content/70'
            }`}
        >
            {expired ? <MdEventBusy /> : <MdEventAvailable />}
            <span>
                {expired ? 'Guia vencida em ' : 'Guia válida até '}
                {dateLabel}
            </span>
        </div>
    )
}
